import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { QwenCommandDto, QwenService } from './qwen.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

import { QwenCommandListComponent } from '../qwen-command-list/qwen-command-list.component';

@Component({
  selector: 'app-qwen',
  standalone: true,
  imports: [CommonModule, QwenCommandListComponent],
  templateUrl: './qwen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './qwen.component.scss'
})
export class QwenComponent implements OnInit {
  commands: QwenCommandDto[] = [];

  constructor(
    private qwenService: QwenService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadCommands();
  }

  loadCommands(): void {
    this.qwenService.getQwenCommands().subscribe({
      next: (data) => {
        this.commands = data;
      },
      error: (err) => {
        this.toastr.error('Failed to load Qwen commands: ' + err.message);
      }
    });
  }
}
